import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import Button from "../components/ds/Button";
import Checkbox from "../components/ds/Checkbox";
import Icon from "../components/ds/Icon";
import Message from "../components/ds/Message";
import Modal from "../components/ds/Modal";
import Options from "../components/ds/Options";
import Overlay from "../components/ds/Overlay";
import Tag from "../components/ds/Tag";
import { partialSelect } from "../modules/table";
import { postState } from "../constants";

const postStateToText = (post) => {
  switch (post.state) {
    case 'draft':
      return 'Borrador';
    case 'published':
      return dayjs(post.published_at).format('DD/MM/YYYY hh:mm A');
    case 'scheduled':
      return 'Programado';
    default:
      return 'Desconocido';
  }
};

const postStateToIcon = {
  'draft': 'pencil',
  'published': 'success',
  'scheduled': 'clock'
};

export default function RowPost({
  post,
  onView,
  onUnpublish,
  onPinToHome,
  onUnpinFromHome,
  onDelete,
}) {
  const [options, setOptions] = useState(false);
  const [stats, setStats] = useState(false);
  const [remove, setRemove] = useState(false);
  const navigate = useNavigate();


  // Options
  useEffect(() => {
    document.body.addEventListener('click', () => setOptions(false));
  }, []);

  function showOptions() {
    setTimeout(() => {
      setOptions(true);
    }, 1);
  }


  return (
    <>
      <div className="row">
        <div className="col-5">
          <Checkbox onchange={partialSelect} />
          {post.pinned_to_home && (
            <span style={{ marginRight: '10px' }} title="Anclado a home">📌</span>
          )}
          <p>{post.title}</p>
        </div>

        <div className="col-2">
          <Tag type="secondary" label={post.category.title} />
        </div>

        <div className="col-2">
          <p style={{ lineHeight: '18px' }}>
            {post.author.name} {post.author.last_name} <br/>
            <span style={{ color: '#999', fontSize: '13px' }}>{post.author.username}</span>
          </p>
        </div>

        <div className="col-2">

          <Icon icon={postStateToIcon[post.state]} />
          <p>{postStateToText(post)}</p>
        </div>

        <div className="col-1">
          <div className="options">
            <button onClick={showOptions}>
              <Icon icon="options" />
            </button>

            {options && (
              <div>
                <Options>
                  {post.state === postState.published ? (
                    <>
                      <li onClick={() => onView(post)}><Icon icon="out" />Ver</li>
                      <li onClick={() => navigate(`/edit-post/${post.id}`)}><Icon icon="pencil" />Editar</li>
                      <li onClick={() => onUnpublish(post)}><Icon icon="offline" />Despublicar</li>

                      {post.pinned_to_home ? (
                        <li onClick={() => onUnpinFromHome(post)}><Icon icon="eye-closed" />Desanclar del inicio</li>
                      ) : (
                        <li onClick={() => onPinToHome(post)}><Icon icon="eye-open" />Anclar al inicio</li>
                      )}
                    </>
                  ) : (
                    <>
                      <li onClick={() => navigate(`/edit-post/${post.id}`)}><Icon icon="pencil" />Editar</li>
                      <li onClick={() => setRemove(true)}><Icon icon="trash" />Eliminar</li>
                    </>
                  )}
                  <li onClick={() => setStats(true)}><Icon icon="graph" />Estadísticas</li>
                </Options>
              </div>
            )}
          </div>
        </div>
      </div>

      {stats && (
        <Overlay>
          <Modal title="Estadísticas" onclose={() => setStats(false)}></Modal>
        </Overlay>
      )}

      {remove && (
        <Overlay>
          <Modal title="Eliminar post" onclose={() => setRemove(false)}>
            <Message type="warning" description={`Seguro que quieres eliminar el post "${post.title}"? Esta acción no se puede deshacer.`} />

            <Button type="destructive" label="Eliminar" onclick={() => onDelete(post)} />
          </Modal>
        </Overlay>
      )}
    </>
  )
}
